import React, {Component} from "react"
import "./index.css"
import {convertPxToRem, myLog} from "../../helper"
import {StyleSheet} from "aphrodite"
import {Col, Layout, Row} from "antd"
import {Colors} from "../../themes/Colors"
import {SVGImageComponentReact} from "../../themes/Images"
import TextBase from "../../common/text"
import withNavigate from "../../component/WithNavigate";
import Logo from '../../assets/image/png/logo.png';

const {Header, Footer, Sider, Content} = Layout
const styles = StyleSheet.create({
    iconApp: {
        width: convertPxToRem(144, true),
        height: convertPxToRem(95, true)
    },
    contentContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        // paddingLeft: convertPxToRem(134, true),
        // paddingTop: convertPxToRem(46, true),
        textAlign: "left",
        right: 0,
        bottom: 0,
        overflow: "hidden"
    },
    containerRight: {
        // paddingLeft: convertPxToRem(134, true),
        paddingTop: convertPxToRem(46, true)
    }
})

class PublicLayout extends Component {
    constructor(props) {
        super(props)
    }

    showOverflow = () => {
        const routeUrl = this.props?.location?.pathname
        // 
        return !(routeUrl === '/privacy' || routeUrl === '/terms');
    }

    render() {
        const {t, isLandingPage, children} = this.props
        myLog("isLandingPage", isLandingPage)
        return (
            <Row
                style={{
                    height: "100vh",
                    overflow: this.showOverflow() ? 'auto' : 'hidden',
                }}
                className="public-layout"
            >
                <Col id="header-public" span={8} xs={24} sm={24} md={12} lg={8}>
                    <div
                        style={{
                            // backgroundColor: Colors.black30,
                            flex: 1,
                            display: "flex",
                            height: "100%",
                            backgroundImage: `url(${require("../../assets/image/auth-bg.jpg")})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center center",
                            backgroundRepeat: "no-repeat",
                            justifyContent: "space-between",
                            flexDirection: "column",
                            paddingInline: 'calc(var(--sp-xxs)*2)'
                        }}
                        id="header-private"
                    >
                        <div
                            style={{
                                display: "flex",
                                backgroundSize: "100%",
                                backgroundPosition: "center center",
                                backgroundRepeat: "no-repeat",
                                height: 'calc(var(--fs-hero)*6.0849)',
                                alignItems: "flex-end",
                                justifyContent: "center"
                            }}
                            id="header-private-child"
                        >
                            <img src={Logo} style={{ height: 'calc(var(--fs-hero)*3.3018)', width: 'calc(var(--fs-hero)*3.3018)' }} />
                            {/* <SVGImageComponentReact.LogoMove/> */}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                backgroundSize: "100%",
                                backgroundPosition: "center center",
                                backgroundRepeat: "no-repeat",
                                flexDirection: "column",
                                justifyContent: "center",
                                height: 'calc(var(--fs-hero)*6.0849)',

                            }}
                            id="header-private-child-2"
                        >
                            <TextBase
                                style={{marginBottom: 'calc(var(--sp-md2)*1.88679)'}}
                                size={'calc(var(--fs-xl)*1.13207)'}
                                color={Colors.white}
                                fontWeight={600}
                            >
                                makeOrderingVeryEasy
                            </TextBase>
                        </div>
                    </div>
                </Col>
                <Col id="header-public-child" style={{backgroundColor: "#fff"}} span={16} xs={24} sm={24} md={12} lg={16}>
                    {children}
                </Col>
            </Row>
        )
    }
}

export default (withNavigate(PublicLayout))

